export default __webpack_public_path__ + "static/media/Bodoni-72-Bold.8280840763a0a570fac65a605ef07a72.ttf";